import styled from 'styled-components'
import {shade} from 'polished'

export const VideoChamadaModal = styled.div`
    padding: 15px 35px;
    display: flex;
    flex-direction: column;
    width: 700px;
    svg{
        margin: 0 0 0 -15px;
    }
    z-index: 20;
`
export const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const MainText = styled.h1`
    font-weight: 500;
    font-size: 20px;
    line-height: 150%;
    color: #2E2E37;
`

export const IconButton = styled.button`
    background: none;
    border: 0;
    outline: 0;
    cursor: pointer;
    position: relative;
    bottom: 10px;
`

export const FormInfo = styled.p`
    font-size: 12px;
    line-height: 150%;
    color: #696977;
    margin-bottom: 10px;
    user-select: none;
`
export const Button = styled.button`
    transition: all 0.2s;
    color: #fff;
    background: #F3123C;
    border-radius: 8px;
    padding: 15px 20px;
    font-size: 14px;
    color: #ECEDF2;
    opacity: ${props => !props.disabled ? '1' : '0.3'};
    cursor: ${props => !props.disabled ? 'pointer' : 'not-allowed'};
    user-select: none;

    &:hover {
        transition: all 0.2s;
        background: ${shade(0.2, '#F3123C')};
    }
`
